import { render, staticRenderFns } from "./layer-statuses-config-form.vue?vue&type=template&id=06ecf01b"
import script from "./layer-statuses-config-form.vue?vue&type=script&lang=js"
export * from "./layer-statuses-config-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports